import React from 'react';
import { useTranslation } from 'react-i18next';

import type { StatsEarnings } from '../../../../mock-data/types';
import { StatCard } from '../StatCard';
import { PrimaryStat } from '../PrimaryStat';
import { SplitStat } from '../SplitStat';
import { Inner, Divider, SplitRow } from './Earnings.styles';

export type EarningsProps = {
  data: StatsEarnings;
  /** While true, the figures show placeholders (the endpoint is loading). */
  loading?: boolean;
};

/** "Earnings" — the Net Revenue lead with Bonus cost / Bonus·GGR-ratio split
 *  stats (no chart). The time range is driven globally from the page header. */
export const Earnings = ({ data, loading = false }: EarningsProps): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <StatCard title={t('Earnings')} sub={t('The movement of real cash')}>
      <Inner>
        <PrimaryStat data={data.netRevenue} loading={loading} />
        <Divider />
        <SplitRow>
          <SplitStat data={data.bonusCost} loading={loading} />
          <SplitStat data={data.bonusGgrRatio} loading={loading} />
        </SplitRow>
      </Inner>
    </StatCard>
  );
};

export default Earnings;
